var map = {
	"./prize-1-bm.webp": 2569,
	"./prize-1-cn.webp": 2570,
	"./prize-1.webp": 2571,
	"./prize-2-bm.webp": 2572,
	"./prize-2-cn.webp": 2573,
	"./prize-2.webp": 2574,
	"./prize-3-bm.webp": 2575,
	"./prize-3-cn.webp": 2576,
	"./prize-3.webp": 2577,
	"./prize-4-bm.webp": 2578,
	"./prize-4-cn.webp": 2579,
	"./prize-4.webp": 2580,
	"./star.svg": 2581
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 929;